@import "~@uipath/apollo-core/src/scss/base-host.scss";

.pt-profile-root {
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--color-background);
    outline: none;
    padding: $pad-xs;

    &.button {
        cursor: pointer;

        &:focus.pt-circ {
            box-shadow: 0 0 0 2px var(--color-hover);
        }

        .pt-circ {
            transition: box-shadow 0.3s;
            box-shadow: 0 0 0 0 var(--color-hover);

            &:hover {
                box-shadow: 0 0 0 2px var(--color-hover);
            }
        }
    }

    &.pt-profile-root-profile-only {
        background-color: var(--color-background);
        border-right: 0px;
    }
}

.pt-circ {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    border-radius: 50%;

    text-transform: uppercase;
    background-color: var(--color-foreground-highlight);
    color: var(--color-background-raised);

    overflow: hidden;
}
